export default {
  name: 'permission',
  components: {},
  props: [],
  data () {
    return {
      group: {},
      permission:{},
      grp_per:{},
      errors:{},
      btn_submit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters['GroupPermission/getPermissions']
    },
    profile () {
      return this.$store.getters['Profile/getProfile']
    }
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Group/showGroup', {group: {id: this.$route.params.group_id}}),
      this.$store.dispatch('GroupPermission/getAllPermission'),
      this.$store.dispatch('GroupPermission/getPermission', {group: {id: this.$route.params.group_id}})
    ]).then(res => {
      this.group = res[0]
      
    }).catch(errors => {
      
    })
  },
  methods: {
    add(){
      this.permission={}
      this.errors={}
      this.$refs.addPer.show()
    },
    addPer () {
      this.btn_submit = true
    
      this.$store.dispatch('GroupPermission/addPermission', {
        permission: this.permission
      }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.addPer.hide()
        this.btn_submit = false
        this.errors = {}
        
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
        
      })
    },
    addGrp () {
      this.btn_submit = true
    
      this.grp_per.parent_id = 0
      this.$store.dispatch('GroupPermission/addGrpPermission', {
        permission: this.grp_per
      }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.addPer.hide()
        this.btn_submit = false
        this.errors = {}
        
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
        
      })
    },
    save () {
      var permissions = this.$store.getters['GroupPermission/getSelectPermission']
    
      this.$store.dispatch('GroupPermission/createPermission', {group: {id: this.$route.params.group_id}, permissions: permissions}).then(res => {
        
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group/permission/permission.js